<script lang="ts">
import { defineComponent } from 'vue'
import DocumentsTable from '../components/DocumentsTable.vue'

export default defineComponent({
  name: 'documents-list',
  data() {
    return {
      id: 'all',
    }
  },
  components: { DocumentsTable },
})
</script>

<template>
  <main class="flex-1">
    <div class="py-6">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 class="text-2xl font-semibold text-gray-900">Zoznam dokladov</h1>
      </div>
      <documents-table :hladaj="id"></documents-table>
    </div>
  </main>
</template>
